import type { UserReference } from '@core/account-types';
import type { Candidate } from '@core/candidate-types';

export enum EntityStoreKey {
  Tasks = 'tasks',
}

export enum TasksDataScope {
  All = 'all',
  Candidate = 'candidate',
}

export type TasksReference =
  | (UserReference & { type: 'Admin' })
  | (Candidate & { type: 'Candidate' });

export type TaskPayload = {
  id: number | null;
  title: string;
  completed: boolean;
  description: string;
  dueDate: string | null;
  timezone: string | null;
  candidateId: number | null;
  adminIds: number[];
};

export type TaskCreatePayload = Pick<
  TaskPayload,
  'title' | 'dueDate' | 'timezone' | 'candidateId' | 'adminIds'
>;

export enum TaskErrorCode {
  CannotAssignAdminWithoutAccess = 'cannot_assign_admin_without_access',
}
